import {atom} from 'recoil';
import {ListRange} from 'react-virtuoso';
import {AxiosResponse} from 'axios';

export const reportsState = atom<any[]>({
  key: 'reportsState',
  default: [],
});

export const preservedScrollPosState = atom<ListRange>({
  key: 'preservedScrollPosState',
  default: {endIndex: 0, startIndex: 0},
});

export const reportDataState = atom<{
  name: string;
  report: AxiosResponse<Blob>;
} | null>({
  key: 'reportDataState',
  default: null,
});
